import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { FunctionsService, HttpService, MessageService, SessionService } from 'brainloper-ui';
import { NotificationsService } from './notifications.service';
import { Resources } from 'app/models2/maintenance/resources';
import { User } from 'app/models2/administration/user';
import { Provider } from 'app/models2/administration/provider';
import { WorkOrder } from 'app/models2/maintenance/work-order';
import { dataWO } from 'app/models2/maintenance/data-wo';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { BaseResponse } from 'app/models2/commos/base-response';
import { TypeOfMaintenance, TypeMaintenance} from '@edgarzon93/brainloper-shared';


@Injectable({
  providedIn: 'root'
})
export class WorkOrderService {

  urlPostOT: string = `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}`
  urlGetTableUsersOrder: string = `${EndpointDictionary.UserOrder.USER_ORDER_TABLE}`
  urlAuthorizeOrder: string = `${EndpointDictionary.WorkOrder.WORK_ORDER_AUTHORIZE}`
  urlNotifications: string = `${EndpointDictionary.Notification.CRUD_NOTIFICATION_DATA}`
  urlPostUsuariosOT: string = `${EndpointDictionary.UserOrder.CRUD_USER_ORDER_DATA}`
  urlGetTablaUsuariosOrdenes: string = `${EndpointDictionary.UserOrder.USER_ORDER_TABLE}`

  constructor(
    private message: MessageService,
    private http: HttpService,
    public notificationService: NotificationsService,
    private session: SessionService,
    private location: Location,
    private router: Router,
    private functionEter: FunctionsService,
  ) { }

  public async updateWO(form: WorkOrder, data: dataWO) {
    this.message.openLoading('Cargando', 'Actualizando orden de trabajo')
    form.id = data.body[0].id
    form.activityId = data.body[0].activityId
    form.equipmentId = data.body[0].equipmentId
    form.active = data.body[0].active
    form.authorized = data.body[0].autorized
    form.creatorId = data.body[0].creatorId
    form.maintenanceType = data.body[0].maintenanceType
    form.executionDate = this.functionEter.dateForm(form.executionDate)

    try {
      let res: GenericResponse = await this.http.putDataBody(`${this.urlPostOT}`, form)
      if (res) {
        this.message.closeLoading()
        this.message.SuccessToast('Orden de trabajo actualizada correctamente')
        setTimeout(() => {
          this.location.back()
        }, 500);
      }

    } catch (error) {
      this.message.Error('Error', `${error}`)
    }
  }

  public async addWO(form: WorkOrder,
    maintenanceType: string,
    activityId: number,
  ) {
    let id_orden: number = 0
    if (maintenanceType == 'preventivo' || maintenanceType == 'predictivo') {
      form.activityId = activityId;
    } else {
      form.activityId = 0
    }
    try {
      form.maintenanceType = maintenanceType     
      let res: GenericResponse = await this.http.postDataBody(`${this.urlPostOT}`, form)
      if (res) {
        id_orden = res.insertId
        return id_orden
      }
    } catch (error) {
      this.message.Error('Error', `${error}`)
      return id_orden
    }
  }

  async editOT(idOT: number): Promise<boolean> {
    let res: Array<WorkOrder> = await this.http.getDataBody(`${this.urlPostOT}/${idOT}`, [{ id: 'withUserWo', value: 'true' }])
    if (res) {
      let reponsable = res[0].userWO.length > 0 ? res[0].userWO[0].responsibleType : "tercero"
      this.session.setData('data', { action: 'edit', body: res, reponsable })
      return true

    } else {
      return false
    }

  }

  async authorizeWorkOrder(response: Array<boolean | WorkOrder | User[] | Provider[] | Array<Resources>>, notificationId: number) {
    try {
      let workOrder = response[1] as WorkOrder
      let bodyUsers = response[2] as User[] | Provider[]
      let resources = response[3] as Array<Resources>
      if (response[0] as boolean) {
        this.message.openLoading('Cargando', 'Autorizando notificación')
        let resAutoriza: GenericResponse = await this.http.putDataBody(`${this.urlAuthorizeOrder}`, { id: workOrder.id })
        if (resAutoriza) {
          // response[4] if company has inventoy module
          if (response[4]) {
            if (resources.length > 0) {
              await this.notificationService.sendNotificationStorer(`Equipo: ${workOrder.code} / ${workOrder.description}`, workOrder.id)
            }
            else {
              this.notificationService.sendOrderRadyNotification(workOrder, bodyUsers, [], notificationId)
            }
          } else {
            await this.notificationService.sendNotificationMaintenance(`Equipo: ${workOrder.code} / ${workOrder.description}`, workOrder.id, workOrder.responsibleId)
            if (!bodyUsers[0]['providerId']) {
              await this.notificationService.sendNotificationsMaintenanceByUsers(workOrder, bodyUsers)
            }
          }
          this.notificationService.deleteNotificationById({ id: notificationId })
          setTimeout(() => {
            this.router.navigate(['/inicio'])
          }, 500);
          this.message.closeLoading()
          this.message.SuccessToast('Notificacion Autorizada')
        }
      } else {
        this.message.Warning('Desea rechazar la solicitud', '', true).then(
          (res: boolean) => {
            if (res == true) {
              this.declineAuthorization(workOrder, notificationId)
            }
          }
        )
      }
    } catch (error) {
      this.message.Error('Error', error['message'])
    }
  }

  async declineAuthorization(workOrder: WorkOrder, notificationId: number) {
    this.message.openLoading('Cargando', 'Rechazando notificación')
    let bodyNotification = {
      descripcion: `Solicitud rechazada ${workOrder.description}`,
      notificado: workOrder.responsibleId
    }
    let resDeleteOT: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(`${this.urlPostOT}/${workOrder.id}`)
    let resDeleteNotificacion: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(`${this.urlNotifications}/${notificationId}`)
    if (resDeleteOT['code'] === 0) {
      if (resDeleteNotificacion['code'] === 0) {
        this.message.closeLoading()
        this.message.SuccessToast('Notificacion Rechazada')
        await this.notificationService.sendNotificationInformative(bodyNotification.descripcion, bodyNotification.notificado)
        setTimeout(() => {
          this.router.navigate(['/inicio'])
        }, 500);
      } else {
        this.message.Error('Error', resDeleteNotificacion['message'])
      }


    } else {
      this.message.Error('Error', resDeleteOT['message'])
    }
  }

  public async getTypeOfMaintenance(): Promise<TypeMaintenance[]> {
    return await TypeOfMaintenance.filter((x) => x.active);
  }
}
